import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getUnassignedTxn = createAsyncThunk(
  "settlement/getUnassignedTxn",
  async () => {
    const response = await axios.get(`/api/business/getUnassignedTxn`);
    return response.response;
  }
);

export const getSettledDeals = createAsyncThunk(
  "settlement/getSettledDeals",
  async () => {
    const response = await axios.get(`/api/business/getSettledDeals`);
    return response.response;
  }
);

export const SettlementSlice = createSlice({
  name: "settlement",
  initialState: {
    loading: false,
    error: "",
    unassignTrans: [],
    settledTrans: [],
  },

  extraReducers: (builder) => {
    builder.addCase(getUnassignedTxn.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getUnassignedTxn.fulfilled, (state, action) => {
      state.loading = false;
      state.unassignTrans = action.payload;
      state.error = "";
    });
    builder.addCase(getUnassignedTxn.rejected, (state, action) => {
      state.loading = false;
      state.unassignTrans = [];
      state.error = action.payload;
    });
    builder.addCase(getSettledDeals.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getSettledDeals.fulfilled, (state, action) => {
      state.loading = false;
      state.settledTrans = action.payload;
      state.error = "";
    });
    builder.addCase(getSettledDeals.rejected, (state, action) => {
      state.loading = false;
      state.settledTrans = [];
      state.error = action.payload;
    });
  },

  reducers: {},
});

// eslint-disable-next-line no-empty-pattern
export const {} = SettlementSlice.actions;

export default SettlementSlice.reducer;
